var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmile5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.555,
    height: 84.555,
    viewBox: "0 0 84.555 84.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1727",
    "data-name": "Group 1727",
    transform: "translate(1156.555 -995.223)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 42.277,
    cy: 42.277,
    r: 42.277,
    transform: "translate(-1156.555 995.223)",
    fill: "#ffd442"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 18.119,
    cy: 10.066,
    rx: 18.119,
    ry: 10.066,
    transform: "translate(-1132.845 1047.566)",
    fill: "#594504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M3792.574,1141.092s8.064-13.871,8.2-18.489-3.369-10.03-8.2-8.11-6.207,5.245-6.207,5.245-10.718-4.169-12.179,2.866S3792.574,1141.092,3792.574,1141.092Z",
    transform: "translate(-4922.613 -98.359)",
    fill: "#f4606e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M3782.318,1141.092s-8.063-13.871-8.2-18.489,3.37-10.03,8.2-8.11,6.208,5.245,6.208,5.245,10.718-4.169,12.179,2.866S3782.318,1141.092,3782.318,1141.092Z",
    transform: "translate(-4882.349 -98.359)",
    fill: "#f4606e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile5);
export default __webpack_public_path__ + "static/media/smile5.c14f493114387577a3c1387ce6227cdc.svg";
export { ForwardRef as ReactComponent };